$(document).ready(function(){

  $(document).on('change','.select-soup-main',function(){
   var sp =  $(this).val();
  var foodshd = $(this).attr('data-shedule');
    // alert(sp + foodshd);
  });

$(document).on('click', '.btn-checkout-btn', function() {
    var $ = jQuery;
    var proid = $(this).parent().find('.iditem').val();
    var qty = $(this).parent().find('.myqty').val();
    
    var properties = {};
    

    $('.select-soup-main').each(function() {
        var schedule = $(this).attr('data-shedule');
        var day = $(this).attr('data-name');
        var selectedValue = $(this).val();
        
        properties[`${day} ${schedule}`] = selectedValue;
    });

    var formData = {
        items: [{
            id: proid,
            quantity: qty,
            properties: properties
        }]
    };
   // var formparams = $('form').serialize();
    console.log(formData);


    $.ajax({
        url: "/cart/add",
        type: "post",
        data: formData, 
        // contentType: 'application/json', 
        success: function(response) {
            console.log('Items added to cart:');
            window.location.href = "/checkout"; 
        },
        error: function(xhr, status, error) {
            console.log('Error adding to cart:', error);
            console.log('Response:', xhr.responseText); 
        }
    });
});

            });